import { delay } from 'redux-saga'
import { call, fork, put, takeLatest, all } from 'redux-saga/effects';

import { actions, api } from './';
import { updateSubmissionRatingOptions as updateSubmissionRatingOptionsAction } from '../submissions/actions';

export function* fetchRatings(action) {
    yield call(delay, 650) // debounce here rather than within the Quote component

    const { params } = action.value

    try {
        const ratings = yield call(api.fetch, params)
        yield all([
            put(actions.fetchSuccess(ratings)),
            put(updateSubmissionRatingOptionsAction(ratings.options)),
        ]);
    } catch (e) {
        yield put(actions.fetchFailure(e))
    }
}

export function* fetchRatingsNoPricing(action) {

    const { params } = action.value

    try {
        const ratings = yield call(api.fetch, params)
        yield all([
            put(actions.fetchRatingsNoPricingSuccess(ratings)),
            put(updateSubmissionRatingOptionsAction(ratings.options)),
        ]);
    } catch (e) {
        yield put(actions.fetchRatingsNoPricingFailure(e))
    }
}

function* watchForFetchRatings() {
    yield takeLatest(actions.FETCH_RATINGS, fetchRatings)
}

function* watchForFetchRatingsNoPricing() {
    yield takeLatest(actions.FETCH_RATINGS_NO_PRICING, fetchRatingsNoPricing)
}

export default function* root() {
    yield all([
        fork(watchForFetchRatings),
        fork(watchForFetchRatingsNoPricing)
    ])
}
